const SessionManager = {
  KEYCODE_ENTER: 13,
};

SessionManager.shouldSaveOnEnter = event =>
  event.which === SessionManager.KEYCODE_ENTER && event.target.nodeName !== 'TEXTAREA' && typeof window.disableEnterKey === "undefined";

SessionManager.saveOnEnter = (event) => {
  if (SessionManager.shouldSaveOnEnter(event)) {
    event.preventDefault();
    // enter pressed
    SessionManager.saveAndContinue();
    window._track('Enter Button + Save & Continue', 'Pressed');
  }
};

SessionManager.previewDisplay = function(inBackground, editable, dynamic)
{
    if (!inBackground) {
        inBackground = null;
    };

    SessionManager.previewWithParams(null, null, inBackground, editable, dynamic);
};

SessionManager.previewWithParams = function(key, hash, inBackground, editable, dynamic)
{
    var exportDynamic;

    if (typeof BuilderSettings !== 'undefined') {
        dynamic = dynamic || BuilderSettings.dynamic;
    }

    if (dynamic) {
        exportDynamic = "-dynamic";
    }else{
        exportDynamic = "";
    }

    var fullSource = "export"+exportDynamic+"/theme.php";

    var queryVars = "";
    var currentUrl = SessionManager.getCurrentUrl();

    if (currentUrl.substring(currentUrl.indexOf('?'))) {
        queryVars = currentUrl.substring(currentUrl.indexOf('?'));
        queryVars = queryVars.replace("#", "");
    }

    if (editable) {
        fullSource = "export"+exportDynamic+"/theme-editable.php";
    }

    if (key && hash) {
        fullSource = "export"+exportDynamic+"/theme-print.php";
        $('#previewCanvas').attr('src', fullSource+'?key='+key+'&ses='+hash);
    }else{
        $('#previewCanvas').attr('src', fullSource + queryVars);
    }


    if (!inBackground) {
        $('#previewPane').modal('show');
    };
};

SessionManager.getCurrentUrl = function() {
    return window.location.href;
};



module.exports = SessionManager;



// WEBPACK FOOTER //
// ./src-assets/js/session-manager.js